import { BaseResource } from 'utils/ApiUtils';

export default class WorkItemTracking extends BaseResource {
  static columns = [
    {
      title: "Inspection #",
      field: "InspectionNumber_Inspection"
    },
    { title: "Inspector", field: "Name_SystemUser" },
    {
      title: "Work Item #",
      field: "WorkItemNumber_WorkItem"
    },
    {
      title: "Work Item Description",
      field: "Description_WorkItem"
    },
    {
      title: "Contractor Name",
      field: "ContractorName"
    },
    {
      title: "Pay Indicator",
      field: "Description_PayIndicator"
    },
    {
      title: "Station",
      field: "Description_Station"
    },
    {
      title: "Date Observed",
      field: "dateObserved",
      type: "date"
    },
    {
      title: "Time Begin",
      field: "TimeBegin",
      type: "date"
    },
    {
      title: "Time End",
      field: "TimeEnd",
      type: "date"
    },
    {
      title: "From Sta",
      field: "fromSta"
    },
    {
      title: "To Sta",
      field: "toSta"
    },
    {
      title: "Location",
      field: "location"
    },
    {
      title: "Quantity Installed",
      field: "quantityInstalled",
      type: "numeric"
    },
    {
      title: "Units",
      field: "units"
    },
    {
      title: "Ticket Number",
      field: "ticketNum"
    },
    {
      title: "Load Number",
      field: "loadNumber"
    },
    {
      title: "Plan Number",
      field: "planNumber"
    },
    {
      title: "Pay Indicator %",
      field: "payindicatorPercentage",
      type: "numeric"
    },
    {
      title: "Comments",
      field: "comments"
    }
  ];

  static attributes = WorkItemTracking.columns.map((r) => r.field);

  static expand = [
    {
      ContractorService: {
        expand: {
          ServiceType: {
            select: ["Description"]
          },
          ContractorProject: {
            expand: {
              ContractorNavigation: {
                select: ["Description", "ContractorId"]
              },
              ContractorType: {
                select: ["Description"]
              }
            },
            select: ["ContractorProjectId", "Comments", "MbeDesignation", "MbeLicenseNumber", "FieldUse"]
          }
        }
      }
    },
    {
      PayIndicator: {
        select: ["Description"]
      }
    },
    {
      Station: {
        select: ["Description"]
      }
    },
    {
      "Ihwi": {
        expand: [
          {
            "Inspection": {
              select: ["InspectionNumber"]
            }
          },
          {
            "Inspection": {
              expand:
              {
                "Rassignment": {
                  expand:
                  {
                    "SystemUser": { "select": ["Name"] }
                  }
                }
              }
            }
          },
          {
            "WorkItem": {
              select: ["WorkItemNumber", "Description"]
            }
          }
        ]
      }
    }
  ];

  constructor(args) {
    super(args, WorkItemTracking.attributes);
  }
}
